export default __webpack_public_path__ + "static/media/platform_advantages_icon1.7e65b276.png";